import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateTemplateConfiguration, TemplateConfiguration } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createTemplateConfigurationApi, templateConfigurationKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useInstallShipper(
  onSuccess?: () => void,
): UseMutationResult<TemplateConfiguration, Error, CreateTemplateConfiguration> {
  const client = useApiClient('deliveries');
  const api = createTemplateConfigurationApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<TemplateConfiguration, Error, CreateTemplateConfiguration>({
    mutationFn: (data: CreateTemplateConfiguration) => api.createTemplateConfiguration(data),
    ...createMutationCallbacks({
      errorKey: 'shippers.install.toast.error',
      invalidateKeys: [templateConfigurationKeys.lists()],
      onSuccess,
      queryClient,
      successKey: 'shippers.install.toast.success',
      t,
    }),
  });
}
